import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const SUPPORTED = ['pt', 'en', 'es', 'fr', 'de'] as const;
type Lang = typeof SUPPORTED[number];

const loaders: Record<Lang, () => Promise<Record<string, unknown>>> = {
    pt: () => import('./locales/pt/translations.json').then((m) => m.default as Record<string, unknown>),
    en: () => import('./locales/en/translations.json').then((m) => m.default as Record<string, unknown>),
    es: () => import('./locales/es/translations.json').then((m) => m.default as Record<string, unknown>),
    fr: () => import('./locales/fr/translations.json').then((m) => m.default as Record<string, unknown>),
    de: () => import('./locales/de/translations.json').then((m) => m.default as Record<string, unknown>),
};

function detectLang(): Lang {
    try {
        const seg = window.location.pathname.split('/')[1];
        if ((SUPPORTED as readonly string[]).includes(seg)) return seg as Lang;
        const stored = localStorage.getItem('language');
        if (stored && (SUPPORTED as readonly string[]).includes(stored)) return stored as Lang;
    } catch {}
    return 'pt';
}

async function loadLang(lng: Lang): Promise<void> {
    if (!i18n.hasResourceBundle(lng, 'translations')) {
        const translations = await loaders[lng]();
        i18n.addResourceBundle(lng, 'translations', translations, true, true);
    }
}

const activeLang = detectLang();

i18n.use(initReactI18next).init({
    fallbackLng: 'pt',
    lng: activeLang,
    resources: {},
    ns: ['translations'],
    defaultNS: 'translations',
    react: { useSuspense: true },
});

// load only the active language on startup — each locale is a separate webpack chunk (for improved performance)
loadLang(activeLang);

// load additional languages on demand when the user switches language (for improved performance)
i18n.on('languageChanged', (lng: string) => {
    if ((SUPPORTED as readonly string[]).includes(lng)) loadLang(lng as Lang);
});

export default i18n;
